import React from 'react'
import { useTrafficSource } from '../../hooks/useTrafficSource'

export const TrafficTracker = () => {
  useTrafficSource()
  return null
}
